export default __webpack_public_path__ + "static/media/roomEnter.5efec500.wav";